export const teleMVerticals = ["22", "35", "37", "40"];

export const isTeleMVertical = (verticalId) => {
  return teleMVerticals.includes(String(verticalId));
};
